import {CURRENCY_SYMBOL_MAP} from '../constants/countries';
import {StoreRegionData} from './storeGeoLocator';

export type SkuDynamicResponse = {
  fields: {
    title: string;
    stripeProductId: string;
    stripeProductIdTest: string;
    batchNumber: string;
    deliveryInfo: string;
    remainingInventory: number;
  };
};

export const getBasePrice = (
  basePrice: any[] | any[],
  storeCountry: StoreRegionData[] | undefined
) => {
  if (!storeCountry) return undefined;

  if (!basePrice) return undefined;

  return basePrice.find((price) => {
    if (!price || !price.currency) return false;

    return price.currency === storeCountry[0].currency.toLowerCase();
  });
};

export const getListPrice = (
  stripePrices: any[],
  currentProduct: SkuDynamicResponse | undefined,
  storeCountry: StoreRegionData[] | undefined
) => {
  if (!currentProduct || !storeCountry) return undefined;

  const isLive = stripePrices[0].livemode;
  const currency = storeCountry[0].currency.toLowerCase();
  const {stripeProductId, stripeProductIdTest} = currentProduct.fields;
  const activeProductToFind = isLive ? stripeProductId : stripeProductIdTest;

  // Find the first price with lowest value
  const sortedPrices = stripePrices.sort(
    (a, b) => a.unit_amount - b.unit_amount
  );

  return sortedPrices.find((price) => {
    if (!price || !price.currency) return false;

    return (
      price.currency === currency && activeProductToFind === price.product.id
    );
  });
};

export const getCurrentProduct = (dynamicResponse: SkuDynamicResponse[]) =>
  dynamicResponse.reduce(
    (acc: SkuDynamicResponse | undefined, item: SkuDynamicResponse) => {
      const {batchNumber, remainingInventory} = item.fields;

      if (!acc && item.fields.remainingInventory > 0) return item;
      if (!acc && item.fields.remainingInventory === 0) return undefined;

      const currentBatchInt = parseInt(batchNumber, 10);
      const accBatchInt = acc ? parseInt(acc.fields.batchNumber, 10) : 999;

      if (currentBatchInt < accBatchInt && remainingInventory > 0) {
        return item;
      }

      return acc;
    },
    undefined
  );

export const formatPrice = (
  currency: string,
  unitAmout: number,
  orderQuantity = 1
) => {
  const {prefix, suffix} = CURRENCY_SYMBOL_MAP[currency];

  let valueString = `${(unitAmout / 100) * orderQuantity}`;

  if (valueString.length > 3) {
    valueString = valueString.replace(/.{3}$/, ' $&');
  }

  if (prefix) return `${prefix}${valueString}`;

  if (suffix) return `${valueString}${suffix}`;

  return null;
};
